import { render, staticRenderFns } from "./KeyManagersTab.vue?vue&type=template&id=2188c4ba&"
import script from "./KeyManagersTab.vue?vue&type=script&lang=ts&"
export * from "./KeyManagersTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports